<template>
<span class="tooltip-wrapper">
    <el-tooltip style="padding: 5px;"
                    :open-delay="300"
                    effect="light"
                    placement="top"
                    trigger="click"
                  >
                  <template #content> <div style="max-width: 50vw">{{ description }}</div> </template>
                  <i class="tim-icons icon-bulb-63"></i>


                </el-tooltip>
                 <span v-if="editable" class="tooltip-edit-controls">
                 <el-tooltip
      class="item"
      effect="dark"
      content="Edit ToolTip"
      placement="top-start"
    >
      <el-button
        size="mini"
        :class="row.editMode ? 'btn-primary' : 'btn-secondary'"
        :icon="row.editMode ? 'el-icon-check' : 'el-icon-edit'"
        @click="handleSave(row)"
      ></el-button>
    </el-tooltip>
    <el-tooltip
      v-show="row.editMode"
      class="item"
      effect="dark"
      content="Cancel Edit"
      placement="top-start"
    >
      <el-button
        size="mini"
        class="btn-secondary editing"
        @click="handleCancel(row)"
        >X</el-button
      >
    </el-tooltip>
    <!-- <el-tooltip
      class="item"
      v-show="!row.editMode"
      effect="dark"
      content="Delete ToolTip"
      placement="top-start"
    > -->
      <!-- <el-button
        size="mini"
        class="btn-secondary editing"
        icon="el-icon-delete"
        @click="handleDelete(row)"
      ></el-button> -->
    <!-- </el-tooltip> -->
    <base-input
   class="over_lap"
          v-show="row.editMode"
          name="tooltipDescription"
          v-model="tooltipDescription"
        ></base-input>
      </span>
</span>
</template>

<script>
import Header from "@/components/App/Header";
import { mapState, mapActions, mapGetters } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import { BaseButton, EditableCell } from "@/components";

import {
  Table,
  TableColumn,
  Upload,
  Button,
  Tag,
  Select,
  Option,
  Alert,
  Form,
  FormItem,
  CheckboxGroup,
  Checkbox,
  Divider,
  Tooltip,
  Card,
} from "element-ui";

export default {
    name: "tool-tip",
    methods: {},
    data() {
        return {
            content: "This is testing",
            row:{editMode: false},
            tooltipDescription: ''
        }
    },
    head(){
      return{
        link:{
          rel: "stylesheet",
          href:"https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
        }
      }
    },

  props: {
    name: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
    components: {
    [Card.name]: Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Upload.name]: Upload,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Alert.name]: Alert,
    [Tag.name]: Tag,
    [Form.name]: Form,
    [Tooltip.name]: Tooltip,
    [FormItem.name]: FormItem,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Divider.name]: Divider,
    EditableCell,
    Treeselect,
    Header,
  },
  mounted(){
    this.tooltipDescription =  this.description

  },
  computed:{
    ...mapGetters({
      toolTips: "tooltip/tooltips"

    }
    )
  },
  methods:{
    ...mapActions({
      getToolTip: "tooltip/getToolTips",
      saveToolTip: "tooltip/saveTooltip",
      deleteTooltip: "tooltip/deleteTooltip"
    }),
    handleCancel(row) {
      row.editMode = false;
    },
    handleDelete(row){
      if(row){
        this.deleteTooltip(row).then(()=>{
          this.getToolTip();
        })
      }
    },
    handleSave(row){
    if (row.editMode) {
        // Row Updating Section
        let tooltip = this.toolTips.find(e => e.name === this.name)
        tooltip.description = this.tooltipDescription
        const data = {name : tooltip.name , description :this.tooltipDescription }
        this.saveToolTip(tooltip).then(() => {
          this.$emit('updateToolTip', data  )

          this.getToolTip()

        })
        row.editMode = false;
        
      }else{
        row.editMode = true;
      }
},   
  }
};

</script>
<style scoped>
/* Tooltip wrapper to establish positioning context */
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-edit-controls {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

/* Edit input field styling */
.over_lap {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  z-index: 1000;
  min-width: 300px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  margin-top: 4px;
}

.tim-icons {
  color: green;
}
</style>




